import * as React from 'react';

import { List } from 'immutable';
import RowMessage from './RowMessage';

const withRowMessages = (WrappedComponent) => {
  class WithRowMessages extends React.Component {
    static defaultProps = {
      getItem: () => null,
    };

    getMessages = (row) => {
      const { rowMessages } = this.props;
      return rowMessages.find((m) => m.row === row);
    };

    getItem = (row, col) => {
      const { getItem, rowMessagesRelativeCol } = this.props;
      const message = rowMessagesRelativeCol === col ? this.getMessages(row) : null;
      return (
        <>
          {getItem(row, col)}
          {message && this.renderMessage(message)}
        </>
      );
    };

    renderMessage = (message) => {
      const { messageRender } = this.props;
      return messageRender ? messageRender(message) : <RowMessage {...message.toJS()} />;
    };

    render() {
      return <WrappedComponent {...this.props} getItem={this.getItem} />;
    }
  }

  WithRowMessages.displayName = WrappedComponent.displayName;

  return WithRowMessages;
};

export default withRowMessages;
